import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ExternalResourcesState } from '../../entities/external-resources.state';
import * as fromReducer from '../reducers/external-resources.reducer';

export const selectExternalResourcesState = createFeatureSelector<ExternalResourcesState>(
    fromReducer.externalResourcesFeatureKey,
);

export const selectExternalResourcesLoading = createSelector(selectExternalResourcesState, state => state.isLoading);
export const selectExternalApps = createSelector(selectExternalResourcesState, state => state.externalApplications);
export const selectInternalApps = createSelector(selectExternalResourcesState, state => state.internalApplications);
export const selectSelectedExternalApp = createSelector(selectExternalResourcesState, state => state.activeResource);
export const selectIsFullScreenMode = createSelector(selectExternalResourcesState, state => state.isFullScreen);
